import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachAvailabilityDto } from "../../../models/coach/dto/coach-availability.dto";
import { AddCoachAvailabilitiesInputDto } from "../../../models/coach/dto/set-coach-availabilities.dto";
import { ALL_COACH_CALENDAR_QUERY_KEY } from "../../coach-management/hooks/useGetCoachCalendar";

export const useAddCoachAvailabilities = (onSuccess?: (data: CoachAvailabilityDto[]) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['addCoachAvailabilities'],
        mutationFn: (input: AddCoachAvailabilitiesInputDto) => client.fetchApi<CoachAvailabilityDto[], AddCoachAvailabilitiesInputDto>({ method: 'POST', endpoint: `coachs/${input.coachId}/add-availabilities`, body: input }),
        onSuccess: (data) => {
            queryClient.invalidateQueries(ALL_COACH_CALENDAR_QUERY_KEY(data[0].coachId));
            if (onSuccess)
                onSuccess(data)
        }
    });
}